import { Breakpoints } from "@domun/component-library";
import styled from "styled-components";

export const LoginWrapper = styled.div`
  .container {
    display: none;
    .left {
      width: 50%;
      overflow: hidden;
      .bg-image {
        position: absolute;
        height: 100%;
        z-index: 0;
        width: 50%;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .phone {
        bottom: 0;
        left: 0;
        position: absolute;
        max-width: 1000px;
        img {
          width: 60%;
          height: 60%;
          object-fit: cover;
          @media screen and (min-width: ${Breakpoints.LaptopMedium}) {
            width: 80%;
            height: 80%;
          }
          @media screen and (min-width: ${Breakpoints.LaptopLarge}) {
            width: 100%;
            height: 100%;
          }
        }
        @media screen and (min-width: ${Breakpoints.LaptopMedium}) {
          left: -30px;
        }
        @media screen and (min-width: ${Breakpoints.LaptopMedium}) {
          left: 150px;
        }
        @media screen and (min-width: ${Breakpoints.LaptopLarge}) {
          left: 500px;
        }
      }
    }
    .right {
      width: 50%;
      display: grid;
      place-content: center;
      .container-right {
        padding: 1rem;
        position: relative;
        width: 447px;
        z-index: 99;
      }

      /* Aviso del cupón de registro (campaña QR): confirma el beneficio
         antes de que el usuario empiece a registrarse. */
      .signup-coupon-benefit {
        margin: 0 0 1rem;
        padding: 0.75rem 1rem;
        border-radius: 8px;
        background-color: #eaf7f0;
        border: 1px solid #bfe3d0;
        color: #1c5c3c;
        font-size: 0.875rem;
        line-height: 1.4;
        text-align: center;
      }
    }
    @media screen and (min-width: ${Breakpoints.Tablet}) {
      background-color: #fff;
      display: flex;
      width: 100%;
      height: 100vh;
      overflow: hidden;
    }

    /*
     * El formulario estaba oculto por debajo de Tablet: en movil solo se
     * mostraba la pantalla de descarga de la app, asi que esta pantalla nunca
     * necesito layout movil. Al dejar de bloquear, hay que darselo.
     *
     * Se oculta la columna decorativa (imagenes de fondo posicionadas en
     * absoluto, pensadas para media pantalla) y el formulario pasa a ocupar
     * todo el ancho.
     */
    @media screen and (max-width: ${Breakpoints.Tablet}) {
      background-color: #fff;
      display: flex;
      width: 100%;
      .left {
        display: none;
      }
      .right {
        width: 100%;
        display: flex;
        justify-content: center;
        .container-right {
          width: 100%;
          max-width: 447px;
        }
      }
    }
  }
`;
